import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/product.css";
import ImageSlider from "./ImageSlider";
import { Utils } from "../services/Utils";
import { IProduct } from "../types/Product"
import SkeletonLoader from "./Loader/SkeletonLoader";

const ProductSkeleton: React.FC = () => {
    return (
        <div
            className="product-item column is-one-fifth is-two-fifths-mobile"
        >
            <div className="product-mask">
                <div className="product-hover-slider">
                </div>
                <figure className={`mb-2 image is-4by5`}>
                    <SkeletonLoader lines={3} circles={0} width="80%" height="18px" />
                </figure>
            </div>
            <div className="product-productMetaInfo">
                <div className="product-metainfo-hover">
                    <div className="product-wishlist-button">
                        {/* <button className="button primary-button"><span className="material-symbols-outlined">favorite</span> &nbsp; WISHLIST</button> */}
                    </div>
                </div>
                <h3 className="product-brand"></h3>
                <h4 className="product-product"></h4>
                <div className="product-price">
                    <span>
                        <span className="product-discountedPrice">

                        </span>
                        <span className="product-strike"></span>
                    </span>
                    <span className="product-discountPercentage"></span>
                </div>


            </div>


        </div>
    );
};

export default ProductSkeleton;
